module.exports = __webpack_public_path__ + "static/homeSummer-9e869365e000279e36bbcd63ccbbb16e.gif";